export default "__VITE_ASSET__Ctet1OBA__"